import { WAIT_FOR_ACTION, ERROR_ACTION } from 'redux-wait-for-action';
import * as actionTypes from './actionTypes';
//----------------------------------------------------------------------------------------------------------------------
export const fetchAccount = ()=>({
        type: actionTypes.FETCH_ACCOUNT
    });
export const fetchAccountSuccess = (account)=>({
        type: actionTypes.FETCH_ACCOUNT_SUCCESS,
        payload: {
            account
        }
    });
export const fetchAccountError = (error)=>({
        type: actionTypes.FETCH_ACCOUNT_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchClient = (clientId)=>({
        type: actionTypes.FETCH_CLIENT,
        payload: {
            clientId
        }
    });
export const fetchClientSuccess = (client)=>({
        type: actionTypes.FETCH_CLIENT_SUCCESS,
        payload: {
            client
        }
    });
export const fetchClientError = (error)=>({
        type: actionTypes.FETCH_CLIENT_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const acceptConsents = (scopesConsented, returnUrl)=>({
        type: actionTypes.ACCEPT_CONSENTS,
        payload: {
            scopesConsented,
            returnUrl
        }
    });
export const acceptConsentsSuccess = ()=>({
        type: actionTypes.ACCEPT_CONSENTS_SUCCESS
    });
export const acceptConsentsError = (error)=>({
        type: actionTypes.ACCEPT_CONSENTS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const rejectConsents = (returnUrl)=>({
        type: actionTypes.REJECT_CONSENTS,
        payload: {
            returnUrl
        }
    });
export const rejectConsentsSuccess = ()=>({
        type: actionTypes.REJECT_CONSENTS_SUCCESS
    });
export const rejectConsentsError = (error)=>({
        type: actionTypes.REJECT_CONSENTS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const setClientId = (clientId)=>({
        type: actionTypes.SET_CLIENT_ID,
        payload: {
            clientId
        }
    });
//------------------------------------------------------------------------------------------------------------------
export const initialize = (clientId, scopes, returnUrl)=>({
        type: actionTypes.INITIALIZE,
        [WAIT_FOR_ACTION]: actionTypes.INITIALIZE_SUCCESS,
        [ERROR_ACTION]: actionTypes.INITIALIZE_ERROR,
        payload: {
            clientId,
            scopes,
            returnUrl
        }
    });
export const initializeSuccess = ()=>({
        type: actionTypes.INITIALIZE_SUCCESS,
        payload: {}
    });
export const initializeError = (error)=>({
        type: actionTypes.INITIALIZE_ERROR,
        error
    });
